module.exports = __webpack_public_path__ + "img/feature-8.a6566ebc.png";